import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const TerritoryList = Loadable(lazy(() => import("./TerritoryList")));
const TerritoryForm = Loadable(lazy(() => import("./TerritoryForm")));

const territoryRoutes = [
  {
    path: "/Territory/TerritoryList",
    element: <TerritoryList />,
    permission: PERMISSIONS.Territories.Menu,
  },
  {
    path: "/Territory/TerritoryForm",
    element: <TerritoryForm />,
  },
  {
    path: "/Territory/TerritoryForm/:territoryId",
    element: <TerritoryForm />,
  },
];

export default territoryRoutes;
